import { connect } from 'react-redux'
import CurrentAwarenessMain from 'pages/currentawareness/Main'

const mapStateToProps = (state, ownProps) => ({
  isLargeDesktop: state.layout.deviceType.isLargeDesktop,
  headerHeight: state.layout.headerHeight,
  browser: state.layout.browser,
  pageId: state.layout.pageId,
  isMobile: state.layout.deviceType.isMobile,
  aol: ownProps.aol
})

export default connect(mapStateToProps, null)(CurrentAwarenessMain)
